import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { CarProvidersAuthService } from './auth.service';

@Injectable()
export class AnonymousGuardService {
  message = new BehaviorSubject('message');

  currentMessage = this.message.asObservable();

  constructor(private auth: CarProvidersAuthService, private router: Router) { }

  changeMessage(message: string) {
    this.message.next(message);
  }

  canActivate() {
    if (!this.auth.isAuthenticated()) {
      return true;
    }
    this.currentMessage.subscribe((response: any) => {
      if (response && response === 'isDocs') {
        this.router.navigate(['/elements-logo']);
        return false;
      } else {
        this.router.navigate(['/home']);
        return false;
      }
    });
  }
}